<template>
  <div class="container">

    <div ref="containerTop" class="containerTop">
      <a href="" target="_blank">
        <img :src="content.fileName" style="width: 100%" v-if="viewImgTop" />
      </a>
    </div>
    
    <el-collapse-transition>
      <div class="containerAd" v-show="viewAdSmall">
        <a href="" target="_blank">
          <img src="../assets/kg/gg_small_new.jpg" alt="" style="width: 100% ;" />
        </a>
      </div> 
    </el-collapse-transition>
    
    <div class="containerWrap" :style="containerStyle">
      <div class="topLogo">
        <div class="topLogoMain">
          <div class="topLogoMainLeft">
            <router-link to="/">
              <img src="../assets/kg/logo.png"  class="Nlogo">
            </router-link>
          </div>
          <div class="topLogoMainRight">

            <div class="header_search">
              <div>
                <input type="text" v-model="searchValue" name="KeyWord" required="required" placeholder="请输入关键字搜索" class="form-control" style="float:left;">  
                <el-button 
                  type="submit" 
                  class="btn " 
                  @click="handleSearch"
                  style="float:left; background-color:#FFFFFF; 
                  border-radius:0px;"><i class="iconfont">&#xe782; </i>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="topMenu">
        <div class="topMenuMain">
          <div class="nav_box">
            <ul  class="menuUL">
              <li class="menuLi">
                <div class="nav_grop">
                  <h2><router-link to="/">网站首页</router-link></h2>
                  <span class="span1"></span>
                </div>
              </li>
              <li v-for="(item, index) in navList" :key="index" class="menuLi">
                <div
                  class="nav_grop" 
                  @mouseenter="navShow(item.channelId)"
                  @mouseleave="navClose()">
                    <h2>
                      <a 
                        v-if="item.url && item.url !== ''" 
                        :href="item.item.url">
                        {{item.name}}
                      </a>
                      <a 
                        v-else
                        :href="item.catalog == 1 ? `/listPage/${item.entTChannelUuid}` : item.catalog == 2 ? `/list/${item.entTChannelUuid}` : `/listPic/${item.entTChannelUuid}`">
                        {{item.name}}
                      </a>
                    </h2>

                    <el-collapse-transition>
                      <div class="nav_down" v-show="navDown == item.channelId"  :class="{ active: item.channelId == '812' }">
                        <div class="transition-box" v-show="item.child.length != 0">
                          <p v-for="(item1, index1) in item.child" :key="index1" class="transitLI">
                            <a 
                              v-if="item1.url && item1.url !== ''" 
                              target="_blank" 
                              :href="item1.url">
                              {{item1.name}}
                            </a>
                            <a 
                              v-else
                              :href="item1.catalog == 1 ? `/listPage/${item1.entTChannelUuid}` : item1.catalog == 2 ? `/list/${item1.entTChannelUuid}` : `/listPic/${item1.entTChannelUuid}`">
                              {{item1.name}}
                            </a>
                          </p>
                        </div>
                      </div>
                    </el-collapse-transition>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main" style="background-color: #fff">
        <router-view></router-view>
      </div>
      
      <div class="foot">
        <div class="main_panel ">
          <div class="pull-left f_logo">
            <img src="../assets/kg/logo-dibu.png">
          </div>
          <div class="pull-right f_text">
            <p>
              <span>Copyright ©&nbsp;2020&nbsp; 甘肃省科工建设集团有限公司&nbsp;&nbsp;All Rights Reserved </span>
            </p>
            <p>
              <span>
                <a href="https://beian.miit.gov.cn" target="_blank">陇ICP备16002456号-2</a>
                </span>
                &nbsp;&nbsp;
              <span>
                <img src="../assets/kg/bei.png">
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62012102000035"><span>甘公网安备 62012102000035号</span></a>
              </span>&nbsp;&nbsp;
            </p>
            <p>地址：甘肃省兰州市兰州新区昆仑山大道 660号中段&nbsp;&nbsp; </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNavChannel , getAdvert} from '@/api/common'

export default {
  name: '',
  data(){
    return {
      content: '',
      searchValue: '',
      active: 0,
      navList: [],
      navDown: 0,
      viewAdSmall: false,
      containerStyle: {},
      viewImgTop: true,
    }
  },
  mounted(){
    this.getPath()
    this.getNavChannel()
    let url = this.$route.name
    if (url == 'home') {
      this.srollimg()
    }
    
  },
  created(){

  },
  watch:{
    '$route':'getPath'
  },
  methods: {
    srollimg() {
      var _this = this
      let data = {
        applicationUuid: _this.webId,
        advertType: 4
      }
      getAdvert(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          data.length && (_this.content = data[0])
          this.$nextTick(() => {
            this.srollTop()
          })
        }
      })
    },

    srollTop() {
      var _this = this
      var heightT
      setTimeout(() => {
        heightT = this.$refs.containerTop.offsetHeight - 10
        _this.containerStyle = {
          marginTop: heightT + 'px'
        }
      }, 1500)
      setTimeout(() => {
        _this.containerStyle = {
          marginTop: 0
        }
      }, 4800)
      setTimeout(() => {
         _this.viewImgTop = false
        _this.viewAdSmall = true
      }, 6600)
    },

    // 获取导航
    getNavChannel() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getNavChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.navList = data.slice(0, 8)
        }
      })
    },
    handleSearch() {
      var _this = this
      if (!_this.searchValue || _this.searchValue == '') {
        this.$message({
          message: '请输入关键词',
          type: 'warning'
        })
      } else {
        window.location.href = `/search/${_this.searchValue}`
      }
    },
    // 二级导航展开
    navShow(d){
      let _this = this
      // _this[d] = true
      _this.navDown = d
    },
    // 二级导航收起
    navClose(){
      let _this = this
      // _this[d] = false
      _this.navDown = 0
    },
    haddleNav(index, params){
      var _this = this

      _this.active = index
      _this.$router.push(params.url)
    },
    getPath(){
      var _this = this
      _this.active = _this.$route.meta.index
    },
  
  }
}
</script>

<style lang="scss">

@font-face {
  font-family: 'iconfont';  /* Project id 3165120 */
  src: url('//at.alicdn.com/t/font_3165120_76d7pwtenjr.woff2?t=1645689140903') format('woff2'),
       url('//at.alicdn.com/t/font_3165120_76d7pwtenjr.woff?t=1645689140903') format('woff'),
       url('//at.alicdn.com/t/font_3165120_76d7pwtenjr.ttf?t=1645689140903') format('truetype');
}

@font-face {
  font-family: 'iconfont';  /* project id 3165259 */
  src: url('');
  src: url('?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_3165259_4zwhtyd54xp.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_3165259_4zwhtyd54xp.woff') format('woff'),
  url('//at.alicdn.com/t/font_3165259_4zwhtyd54xp.ttf') format('truetype'),
  url('#iconfont') format('svg');
}

.iconfont{
  font-family:"iconfont" !important;
  font-size:24px;font-style:normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;}

.topLogo{
  overflow: hidden;
  padding: 0px 0px;
  height: 114px;
}
.topLogoMain{
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.topLogoMainLeft{
  width: 665px;
  height: 91px;
  overflow: hidden;
  margin-top: 11px;
}
.topLogoMainLeft {
  float: left!important;
}
.topLogoMainRight{
  width: 380px;
  height: 110px;
  margin-top: 30px;
  overflow: hidden;
}
.topLogoMainRight {
  float: right!important;
}
.header_search{
  width: 340px;
  height: 51px;
  overflow: hidden;
  float: right;
  position: relative;
  margin-top: 10px;
}
.header_search input {
  width: 250px;
  height: 24px;
  overflow: hidden;
  outline: none;
  box-shadow: none;
  line-height: 352px;
  font-size: 16px;
  color: #585858;
  border-radius: 0px;
  border: solid 1px #0062b2;
  background-color: #fff;
}
.form-control {
  display: block;
  padding: 6px 12px;
}
.btn {
  display: inline-block;
  height: 38px;
  line-height: 38px;
  padding: 0px 12px;
  color: #0062b2;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border: none;
  cursor: pointer;
}
.topMenu{
  height: 46px;
  background-color: #0062b2;
}
.topMenuMain{
  width: 100%;
  height: auto;
  // overflow: hidden;
  margin: 0 auto;
  text-align: center;
}
.topMenuMain .menuUL{
  width: 1200px;
  margin: 0 auto;
  height: 46px;
  overflow: visible;
}
.topMenuMain .menuUL .menuLi {
    position: relative;
    line-height: 46px;
    text-align: center;
    float: left;
    color: #FFFFFF;
    display: block;
    font-size: 16px;
    z-index: 22;
    margin-left: 2px;
    width: 131px;
    height: 46px;
    overflow: visible;
}
.topMenuMain .menuUL  li:hover {
  background-color: #0157a4;
 }
.topMenuMain .menuLi a {
    font-family: "微软雅黑", "Microsoft YaHei", sans-serif;
    font-size: 16px;
    color: #ffffff;
}

.topMenuMain .menuLi a {
    font-family: "微软雅黑", "Microsoft YaHei", sans-serif;
    font-size: 18px;
    color: #ffffff;
    display: block;
    height: 46px;
    font-weight: 600
}
.transition-box .transitLI{
  background-color: #0062b1;
  width: 100%;
  height: 41px;
  overflow: hidden;
  border-top: solid 1px #7db3ea;
  white-space: nowrap;
}
.transition-box .transitLI a {
    color: #fff;
    line-height: 41px;
    font-size: 16px;
    font-weight: normal;
}
.transition-box .transitLI a:hover{
    background-color: #0157a4;
    color: rgb(125, 179, 234);
}



.container .headerTop {
  display: none;
}
.containerAd {
  -moz-transition: all 1s ease-in;
  -webkit-transition: all 1s ease-in;
  -o-transition: all 1s ease-in;
  transition: all 1s ease-in;
}
.containerAd img {
  width: 100%;
  height: auto;
}
.containerWrap {
    -moz-transition: all 2s ease-out;
    -webkit-transition: all 2s ease-out;
    -o-transition: all 2s ease-out;
    transition: all 2s ease-out;
    z-index: 10;
    background-color: #fff;
}
.containerTop {
  position: fixed;
    width: 100%;
    height: auto;
    top: 0;
    left: 0;
    z-index: -10;
    overflow: hidden;
    -moz-transition: all 2s ease-out;
    -webkit-transition: all 2s ease-out;
    -o-transition: all 2s ease-out;
    transition: all 2s ease-out;
}
.containerTop img {
    width: 100%;
    height: 100%;
    display: block;
}
.foot {
    width: 100%;
    background-color: #004b8e;
    color: #FFFFFF;
    height: 208px;
    overflow: hidden;
    padding-top: 60px;
    box-sizing: border-box;
}
.main_panel {
    width: 1200px;
    height: auto;
    overflow: hidden;
    margin: 0 auto;
}
.foot .f_logo {
    width: 600px;
    height: auto;
    overflow: hidden;
}
.pull-left {
    float: left!important;
}
.foot .f_text {
    width: 600px;
    height: auto;
    overflow: hidden;
    line-height: 37px;
}
.pull-right {
    float: right!important;
}
.foot .f_text p a {
    color: #FFFFFF;
    font-size: 16px;
}
.nav_down.active {
  overflow: inherit !important;
}
.nav_down.active .transition-box .transitLI {
    background-color: #0062b1;
    width: 160%;
    height: 41px;
    overflow: hidden;
    border-top: solid 1px #7db3ea;
    white-space: nowrap;
    margin-left: -42px;
}
</style>